var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-unused-vars */ import { useMsal } from '@azure/msal-react';
import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ApplicationContext, ApplicationProvider } from '../../components/ApplicationProvider';
import { ConfigitProvider } from '../../components/ConfigitProvider';
import { DialogComp } from '../../components/DialogComp';
import { LoadingComp } from '../../components/LoadingComp';
import Footer from '../../Footer';
import Header from '../../Header';
import { store } from '../../store';
import { Provider } from 'react-redux';
import { ConfigitProductProvider } from '../../components/ConfigitProductProvider';
import { FMGTelemetry } from 'fmg-telemetry-react';
import FMGTelemetrySetup from '../../utils/FMGTelemetry/FMGTelemetryUtil';
import { isRNDM } from '../../utils/RNDMUtilities';
import { SplashHeader } from '../../pages/Login/SplashHeader';
import SplashFooter from '../../pages/Login/SplashFooter';
import { AuthPlaceholder } from '../../pages/Login/AuthPlaceholder';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Default = function (props) {
    var azureADPCA = useMsal().instance;
    var setLoading = useContext(ApplicationContext).setLoading;
    var _a = useState(false), isReady = _a[0], setIsReady = _a[1];
    useEffect(function () {
        if (isRNDM) {
            var userValidate = function () { return __awaiter(void 0, void 0, void 0, function () {
                var module, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, require('../../utils/UserValidation')];
                        case 1:
                            module = _a.sent();
                            return [4 /*yield*/, module.userValidation(azureADPCA, setLoading)];
                        case 2:
                            result = _a.sent();
                            if (!(result === true)) return [3 /*break*/, 3];
                            setIsReady(true);
                            return [3 /*break*/, 5];
                        case 3: // Validation failed — session may have expired with no active account,
                        // causing the logoutRedirect inside userValidation to fail silently.
                        // Explicitly redirect to login so the user is not stuck on the auth placeholder.
                        return [4 /*yield*/, azureADPCA.logoutRedirect().catch(function () { return setLoading(false); })];
                        case 4:
                            // causing the logoutRedirect inside userValidation to fail silently.
                            // Explicitly redirect to login so the user is not stuck on the auth placeholder.
                            _a.sent();
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); };
            userValidate();
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", { children: /*#__PURE__*/ _jsx(FMGTelemetry, { telemetryOptions: FMGTelemetrySetup, children: /*#__PURE__*/ _jsx(Provider, { store: store, children: /*#__PURE__*/ _jsxs(ApplicationProvider, { children: [/*#__PURE__*/ _jsx(LoadingComp, {}), /*#__PURE__*/ _jsx(ConfigitProvider, { children: /*#__PURE__*/ _jsx(ConfigitProductProvider, { children: !isRNDM || isRNDM && isReady ? /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Header, {}), /*#__PURE__*/ _jsx(DialogComp, {}), /*#__PURE__*/ _jsx(Outlet, {}), /*#__PURE__*/ _jsx(Footer, {})] }) : /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(SplashHeader, {}), /*#__PURE__*/ _jsx(DialogComp, {}), /*#__PURE__*/ _jsx(AuthPlaceholder, {}), /*#__PURE__*/ _jsx(SplashFooter, {})] }) }) })] }) }) }) });
};
